<template>
  <div
    class="home-wrapper"
    v-if="activityData"
    :style="{ 'background-color': activityData.bgColor || '#fff' }"
  >
    <div class="coupon-image">
      <img :src="activityData.image" alt="" />
      <div class="coupon-image-buttom" :style="'background: linear-gradient(to top, '+ (activityData.bgColor || '#fff') +' 10%, transparent)'"></div>
    </div>
    <div class="coupon-content">
      <div
        class="coupon-code"
        :style="{
          'border-color': activityData.brColor,
          color: activityData.brColor,
        }"
        v-if="code"
      >
        <div
          class="coupon-code-msg"
          :style="{ 'border-color': activityData.brColor }"
        >
          {{ activityData.notice }}
        </div>
        <div class="coupon-code-text">{{ code }}</div>
        <div class="coupon-code-name">{{ name }}</div>
      </div>
      <div
        class="coupon-receive-btn"
        :style="{ 'background-color': activityData.brColor }"
        @click="receive"
        v-if="isQuery && !code"
      >
        点击领取
      </div>
      <div
        class="coupon-state"
        :style="'color:' + activityData.brColor"
        v-if="code && detail.state === 1"
      >
        已兑换
      </div>
    </div>
    <div
      id="qrcode"
      ref="qrcode"
      v-show="activityData.qrcode && code && detail.state !== 1"
    ></div>
    <div class="coupon-desc" v-html="activityData.desc"></div>
    <dialog-component @loginEvent="getUserInfon"></dialog-component>
  </div>
</template>

<script>

import COVER from '@/utils/COVER'
import DialogComponent from '@/components/Dialog'
import COVERAPP from '@/utils/COVERAPP'
import Qrcode from 'arale-qrcode'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'Home',
  data() {
    return {
      userinfo: {},
      btnDisabled: false,
      code: '',
      name: '',
      detail: {},
      isQuery: false,
    }
  },
  props: ['activityData'],
  computed: {
    ...mapState(['dialogData']),
  },
  components: {
    DialogComponent
  },
  created() {
    const aid = this.$route.query.id || '';
    this.aid = aid;
  },
  mounted() {
    this.getUserInfon();
    this.$nextTick().then(() => {
      const code = localStorage.getItem('coupon_' + this.aid + '_' + this.userinfo.token + '_code');
      const name = localStorage.getItem('coupon_' + this.aid + '_' + this.userinfo.token + '_name');
      const cid = localStorage.getItem('coupon_' + this.aid + '_' + this.userinfo.token + '_cid');
      this.code = code || '';
      this.name = name || '';
      if (cid && code) {
        this.getPrize(cid, code);
        this.showQRCode(cid, code);
      }
    });
  },
  methods: {
    ...mapActions(['setDialogDataAsync']),
    getUserInfon() {
      let _this = this
      if (COVERAPP.Attribute.isApp()) {
        COVERAPP.Method.GetUser({
          callback(res) {
            let userinfo = JSON.parse(res);
            if (!COVER.isEmpty(userinfo.user_id)) {
              _this.resetUserData(userinfo);
            }
          }
        })
      } else {
        COVER.getUser((res) => {
          _this.userinfo = JSON.parse(JSON.stringify(res));
          _this.getCode();
        })
      }
    },
    //重置用户信息
    resetUserData(info) {
      info.origin = 'app';
      this.userinfo = JSON.parse(JSON.stringify(info));
      this.getCode();
    },
    // 领取优惠券
    receive() {
      const token = this.userinfo.token;

      if (!token) {
        alert('未登录');
        return;
      }
      COVER.$post('/coupon/receive', {
        aid: this.aid,
        token,
        userinfo: this.userinfo,
      }).then(res => {
        if (res.errno === 0) {
          this.code = res.data.code;
          this.name = res.data.name;
          localStorage.setItem('coupon_' + this.aid + '_' + token + '_code', res.data.code);
          localStorage.setItem('coupon_' + this.aid + '_' + token + '_name', res.data.name);
          localStorage.setItem('coupon_' + this.aid + '_' + token + '_cid', res.data.cid);
          if (res.data.cid && this.code) {
            this.showQRCode(res.data.cid, this.code);
            this.getPrize(res.data.cid, this.code);
          }
        } else {
          this.setDialogDataAsync({
            message: res.errmsg,
            btns: [
              {
                text: '确认'
              }
            ]
          })
        }
      });
    },
    async getCode() {
      const token = this.userinfo.token;

      if (token) {
        const res = await COVER.$post('/coupon/getCode', {
          aid: this.aid,
          token,
          userinfo: this.userinfo,
        });

        if (res.errno === 0 && res.data && res.data.code) {
          this.code = res.data.code;
          this.name = res.data.name;
          localStorage.setItem('coupon_' + this.aid + '_' + token + '_code', res.data.code);
          localStorage.setItem('coupon_' + this.aid + '_' + token + '_name', res.data.name);
          localStorage.setItem('coupon_' + this.aid + '_' + token + '_cid', res.data.cid);
          if (res.data.cid && this.code) {
            this.showQRCode(res.data.cid, this.code);
            this.getPrize(res.data.cid, this.code);
          }
        }
      }

      this.isQuery = true;
    },
    setDialogData(msg) {
      this.setDialogDataAsync({
        message: msg,
        btns: [
          {
            text: '确认'
          }
        ]
      })
    },
    // 获取兑奖信息
    async getPrize(cid, code) {
      COVER.$get('/coupon/show?aid=' + this.aid + '&cid=' + cid + '&code=' + code, {}).then(res => {
        if (res.errno === 0) {
          this.detail = res.data;
          this.showQRCode(cid, code);
        }
      })
    },
    showQRCode(cid, code) {
      const location = window.location;
      const url = location.origin + location.pathname + '#/qrcode?id=' + this.aid + '&cid=' + cid + '&code=' + code;
      const qrnode = new Qrcode({
        text: url,
      });
      setTimeout(() => {
        const $qrcode = document.getElementById('qrcode');
        $qrcode.innerHTML = '';
        $qrcode.appendChild(qrnode);
      }, 300);
    }
  }
}
</script>

<style lang="less" scoped>
.home-wrapper {
  overflow: hidden;
  min-height: 100vh;
}
.coupon-image {
  width: 100%;
}
.coupon-image img {
  width: 100%;
  display: table;
}
.coupon-receive-btn {
  width: 60vw;
  margin: 5vh auto;
  font-size: 4.4vw;
  text-align: center;
  padding: 3vw 0;
  color: white;
  border-radius: 1vw;
}
.coupon-state {
  text-align: center;
  margin: 4vw 0;
  font-size: 4.2vw;
}
.coupon-code {
  width: 60vw;
  margin: 5vh auto;
  text-align: center;
  color: #fff;
  border: 1px solid #ffb732;
}
.coupon-code-msg {
  font-size: 4.2vw;
  line-height: 2.5em;
  border-bottom: 1px dashed #ccc;
  width: 80%;
  margin: 0 auto;
}
.coupon-code-text {
  font-size: 6vw;
  line-height: 2em;
}
.coupon-code-name {
  font-size: 3.6vw;
  text-align: center;
}
.coupon-desc {
  width: 90vw;
  margin: 0 auto;
  font-size: 3.6vw;
  line-height: 1.5em;
  color: #fff;
  padding: 3vh 0;
}
.coupon-image-buttom {
  width: 100%;
  height: 20vw;
  margin-top: -19vw;
  position: absolute;
}
#qrcode {
  display: table;
  margin: 20px auto;
  padding: 2vw;
  background: white;
  canvas {
    width: 40vw;
    height: 40vw;
    display: table;
    margin: 0 auto;
  }
}
</style>